/**
 * @name Measurement Date Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

import API from '../config';

const base = `${API.BASE_DEV_HOST}/api/measurement-dates`;

export const getMeasurementDateByFundId = (fundId: string) => `${base}/funds/${fundId}`;
export const measurementDatesByCompanyId = (companyId: number) => `${base}/company/${companyId}`;
export const measurementDatesByFirmId = (firmId: number) => `${base}/firm/${firmId}`;
export const rolloverCompanies = `${base}/company/rollover`;
export const companiesAndfundsByFirmAndDate = (firmId: string, date: string) => `${base}/firm/${firmId}/date/${date}`;
export const allMeasurementDatesByFirmId = (firmId: string) => `${base}/by-firm/${firmId}`;
export const allMeasurementDatesByFirmIdGroupedByFund = (firmId: string) => `${base}/by-firm/${firmId}?group_by=fund`;
export const deleteMeasurementDate = `${base}/delete-related-info`;
